import type { CheDoNen } from '../../components/ThemeProvider';
import type { KhoaDich } from '../../i18n';

export const CHE_DO_NEN_MAC_DINH: CheDoNen = 'auto';

export const CAC_CHE_DO_NEN: readonly { ma: CheDoNen; khoa: KhoaDich }[] = [
  { ma: 'auto', khoa: 'tuyChinh.nenTuDong' },
  { ma: 'light', khoa: 'tuyChinh.nenSang' },
  { ma: 'dark', khoa: 'tuyChinh.nenToi' },
];
